
import React from 'react';

export const PremiumPurchaseEmail = ({
  userName,
  listingTitle,
}: {
  userName: string;
  listingTitle: string;
}) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Konfirmim i Blerjes Premium</title>
</head>
<body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #4F46E5;">Konfirmim i Blerjes Premium</h1>
  </div>
  
  <div style="background-color: #f9f9f9; border-radius: 5px; padding: 20px; margin-bottom: 20px;">
    <h2 style="color: #1F2937;">Detajet e Blerjes Premium</h2>
    <p>I/E nderuar ${userName},</p>
    <p>Faleminderit që bletë paketën premium për shpalljen tuaj:</p>
    <p><strong>${listingTitle}</strong></p>
    <p>Shpallja juaj tani do të shfaqet në pozicion të veçantë për 28 ditë!</p>
  </div>

  <div style="margin-top: 30px; text-align: center; color: #666;">
    <p>Faleminderit që përdorni shërbimet tona!</p>
    <p>© ${new Date().getFullYear()} Tregu.al</p>
  </div>
</body>
</html>
  `;
};
